import { type ImageType, type ImageVariations } from '@Types/Blocks/Image';
import { type ContainerTypeEnums, type PositionsAlignement } from '@Types/Shared/Common';
import { type FrontWPImage } from '@Types/Shared/Image';
import type { ContextKey, Options } from '@Types/Shared/Options';

import { useContext, useEffect, useState, type ComponentProps } from 'react';

import defu from 'defu';
import _ from 'lodash';

import { MinosContext } from '@Shared/Context';

import { getImage } from '@Blocks/_lib/getImageUrl';

import { ImageStyle } from '@/views/Shared/GlobalStyles/GlobalStyles';

import Block from './Block';

declare const minosOptions: string;

type ImageRegister = {
	block: ImageType;
	variant: ImageVariations;
	containerType: ContainerTypeEnums;
	headingAlign: PositionsAlignement;
	context?: ContextKey;
};

export default function Image(props: ImageRegister) {
	const {
		block,
		variant = 'classic',
		containerType = 'wide',
		headingAlign = 'center',
		context = 'front',
	} = props;
	const { composition } = block;
	const [image, setImage] = useState<FrontWPImage>();

	const MinosOptions: Options =
		context === 'front' ? useContext(MinosContext) : JSON.parse(minosOptions);

	let propsImage: ComponentProps<typeof Block> = {
		id: block.id ? block.id : '',
		title: block.title,
		description: block.description,
		titleFormat: block.titleFormat || 'h2',
		inside_title: block.inside_title,
		inside_titleFormat: block.inside_titleFormat,
		inside_description: block.inside_description,
		image: image,
		imageAlt: image?.alt,
		imageUrl: image?.url,
		containerType: containerType,
		variant: variant,
		headingAlign: headingAlign,
		style: {},
		contentFontFormats: block.contentFontFormats,
		ctasStyle: MinosOptions.blocks.image.default.ctasStyle,
		placement: block.placement,
		sectionDecoration: MinosOptions.layout.sectionDecoration,
	};

	useEffect(() => {
		if (block.image) {
			getImage(setImage, block.image, 'large');
		}
	}, [block.image]);

	if (composition && composition != 'none') {
		const compoOptions = _.find(MinosOptions.blocks.image.compositions, { id: composition });
		if (compoOptions) {
			propsImage = defu(compoOptions as ComponentProps<typeof Block>, propsImage);
			propsImage.style = ImageStyle(compoOptions);
		}
	}

	return <Block {...propsImage} />;
}
